import { ApiBase } from '@/api/methods/ApiBase'
import { ApiResponseLearningMemo } from '@/api/responses/study/studyLearnings'

export namespace StudyReviewLearningMemosApi {
  /**
   * 復習BOXの演習メモ登録
   *
   * @param reviewLearningId 演習結果ID
   * @param strokes ストローク情報(JSON文字列をデータ圧縮した値)
   */
  export async function postReviewLearningMemo(reviewLearningId: number, strokes: string): Promise<void> {
    const params = {
      strokes: strokes,
    }
    await ApiBase.post(`/study/reviewLearnings/${reviewLearningId}/memo`, params)
  }

  /**
   * 復習BOXの演習メモ取得
   *
   * @param reviewLearningId 演習結果ID
   * @returns 演習メモ情報
   */
  export async function getReviewLearningMemo(reviewLearningId: number): Promise<ApiResponseLearningMemo> {
    return await ApiBase.get(`/study/reviewLearnings/${reviewLearningId}/memo`)
  }
}
